module.exports = __webpack_public_path__ + "static/bad-luck-and-trouble-e34f0597a679918b06714dac29d4136d.jpg";